module.exports = __webpack_public_path__ + "img/signal_cellular_connected_no_internet_2_bar.2b8f0a05.svg";